module.exports = __webpack_public_path__ + "img/shipment-next.b038f45a.svg";